define('plugin/product/view/ProductIndexItemView',['require','lib/view/LayoutView','lib/theme/ThemeSettings'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var ThemeSettings = require('lib/theme/ThemeSettings');

    /**
     * Product item view
     *
     * @class ProductItemView
     */
    return LayoutView.extend({

        getTemplate: function () {
            if (ThemeSettings.getInstance().getOption('display_item_mode') === 'list') {
                return '#product_index_item_view_list';
            }
            return '#product_index_item_view';
        },
        ui: {
            'qty': '.sb-qty',
            'buy': '.sb-buy',
            'openCart': '.sb-open-cart'
        },
        events: {
            'change @ui.qty': 'onQtyChanged',
            'click @ui.buy': 'onBuyClicked',
            'click @ui.openCart': 'onOpenCartClicked'
        },

        initialize: function () {
            LayoutView.prototype.initialize.call(this);

            this.cart = this.getOption('cart');
            this.listenTo(this.cart, 'sync', this.safeRender);
        },

        safeRender: function () {
            if (!this.isDestroyed) {
                this.render();
            }
        },

        onQtyChanged: function () {
            this.model.set('qty', this.ui.qty.val());
        },

        onBuyClicked: function () {
            this.triggerMethod('buy', this.model.get('id'), this.model.get('qty'));
        },

        onOpenCartClicked: function () {
            this.triggerMethod('open:cart');
        },

        serializeData: function () {
            return _.extend(LayoutView.prototype.serializeData.apply(this, arguments), {
                qty: this.model.get('qty') || 1,
                in_cart: this.cart.contains(this.model.get('id'))
            });
        }

    });

});
